export const question = [
  {
    id: 1,
    question: "Scheme",
    answerType: "text",
    answer: ["Indo Smallholder Dairy Production Finance Scheme"]
  },
  {
    id: 2,
    question: "Purpose",
    answerType: "mixed",
    answer: {
      intro: "The primary objective of the scheme is to facilitate the maintenance and increase in milk production among smallholder dairy farmers through the provision of short-term financing to cover animal feeding and veterinary costs.",
      desc: "Financing will cover:",
      list: [
        "Purchase of dry and fresh fodder such as lucerne, sweet potato vines, wheat straw, rice straw and maize stover",
        "Purchase of wet matter such as molasses and brewer’s yeast",
        "Purchase of minerals and vitamin supplements",
        "Purchase of veterinary medication used in the prevention of diseases and parasites",
        "Purchase of any other Feed, consumption items required in Dairy Production"
      ]
    }
  },
  {
    id: 3,
    question: "Eligibility",
    answerType: "mixed",
    answer: {
      intro: "The following are the eligibility criteria:",
      list: [
        "Smallholder dairy farmers registered with a reputable milk off-taker as a supplier",
        "Smallholder dairy farmer to own a minimum of two (2) dairy cows",
        "Smallholder dairy farmer to have a minimum of 2 years of experience"
      ]
    }
  },
  {
    id: 4,
    question: "Nature of Facility",
    answerType: "text",
    answer: ["Overdraft/Working Capital Facility"]
  },
  {
    id: 5,
    question: "Amount",
    answerType: "text",
    answer: [
      "Dairy milk production loan will be for a maximum of K6,000 per cow per month subject to terms and conditions"
    ]
  },
  {
    id: 6,
    question: "Repayment",
    answerType: "mixed",
    answer: {
      intro: "",
      list: [
        "Maximum period of the overdraft/Working Capital Facility is 12 months, subject to cash flow cycle and number of cows",
        "Farmer will be required to demonstrate continuity of steady milk production and inflows over the period",
        "In the event of unavailability of the above, facility may be limited to a maximum tenure of 5 months",
        "Obligations on the overdraft will be serviced monthly from the date of disbursement",
        "Source of repayment to be proceeds from milk sales to reputable milk off-taker", 
        "Who will transfer funds to the borrower's designated Indo Zambia account"
      ]
    }
  },
  {
    id: 7,
    question: "Currency",
    answerType: "text",
    answer: ["The facility will be in Zambian Kwacha (ZMW)"]
  },
  {
    id: 8,
    question: "Availability of Product",
    answerType: "text",
    answer: ["Available across branch network of the Bank"]
  },
  {
    id: 9,
    question: "Specific Documents",
    answerType: "mixed",
    answer: {
      intro: "The following documents will be required from the borrower:",
      list: [
        "All necessary account opening KYC documents",
        "Documentary evidence of income of the applicant and experience in line of business, if applicable",
        "Loan application",
        "Cash flow projections",
        "Filled-in Bank loan application supported by letter of recommendation from milk off-taker",
        "Confirmation of ownership rights/right of use of farm land for the tenure of proposed finance.",
        "For Traditional Land, this may include Confirmation from Chief/Headman",
        "Details of total livestock inputs required with associated costs",
        "Copies of approvals/licenses/permissions from all applicable authorities, which may include WARMA, PACRA, ZRA, etc.",
        "In the case where Finance is under “MoU” or “Tie-ups” with specific suppliers/distributors/agents/Government programs.",
        "The Bank may consider specific documentation as per specific terms of the “MoU” as approved by delegated sanctioning authority"
      ]
    }
  }
];